import { render, staticRenderFns } from "./parentcustody.vue?vue&type=template&id=33c345e2&scoped=true&"
import script from "./parentcustody.vue?vue&type=script&lang=js&"
export * from "./parentcustody.vue?vue&type=script&lang=js&"
import style0 from "./parentcustody.vue?vue&type=style&index=0&id=33c345e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c345e2",
  null
  
)

export default component.exports